import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=78269936&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformation.vue?vue&type=style&index=0&id=78269936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78269936",
  null
  
)

export default component.exports